// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__I4pYx","banner":"Home_banner__VCUR8","main":"Home_main__msqaq","bookList":"Home_bookList__KNB4N"};